import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 69,
	height: 68,
	viewBox: "0 0 69 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 34.875,
		cy: 34,
		r: 33,
		stroke: "#C80011",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M41.3789 27.5L28.3789 40.5M28.3789 27.5L41.3789 40.5",
		stroke: "#C80011",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFail;
